
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Toggle } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledBoolField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Toggle`}</h1>
<p>{`Similar use to a checkbox, but not used with forms. Normally used to indicate that something has been `}<strong parentName="p">{`"activated"`}</strong>{` rather than `}<strong parentName="p">{`"selected"`}</strong>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Toggle } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledBoolField component={
  <Toggle />
} />`} component={Toggle} mdxType="Playground">
  <ControlledBoolField component={<Toggle mdxType="Toggle" />} mdxType="ControlledBoolField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;